import { render } from "./Wallet.vue?vue&type=template&id=5b6b644a"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Wallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b6b644a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b6b644a', __exports__)) {
    api.reload('5b6b644a', __exports__)
  }
  
  module.hot.accept("./Wallet.vue?vue&type=template&id=5b6b644a", () => {
    api.rerender('5b6b644a', render)
  })

}


export default __exports__